import React, { useEffect, useState } from "react";
import styles from "./PlaydateInviteRecipientView.module.css";
import PlaydateInviteBaseView from "./PlaydateInviteBaseView";
import TextAreaInput from "../../input/TextAreaInput";
import ActionButton from "../../button/ActionButton";
import UnderlineButton from "../../button/UnderlineButton";

type PlaydateInviteContextIngestionViewProps = {
    onBack: () => void;
    onSubmit: (message: string) => void;
    onSkip: () => void;
    existingMessage?: string;
    baseZIndex?: number;
    loading?: boolean;
};

const loadingMessages = [
    "Thinking",
    "Looking at Your Schedule",
    "Putting Invite Together",
    "Almost Ready",
];

const PlaydateInviteContextIngestionView: React.FC<PlaydateInviteContextIngestionViewProps> = ({
    onBack,
    onSubmit,
    onSkip,
    existingMessage,
    baseZIndex,
    loading,
}) => {
    const [message, setMessage] = useState<string>(existingMessage ?? "");

    useEffect(() => {
        if (existingMessage) {
            setMessage(existingMessage);
        }
    }, [existingMessage]);

    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        if (!loading) {
            setMessageIndex(0);
            return;
        }

        let index = 0;
        const maxIndex = loadingMessages.length - 1;

        const interval = setInterval(() => {
            index += 1;
            if (index < maxIndex) {
                setMessageIndex(index);
            } else {
                // Hold on "Almost Ready"
                clearInterval(interval);
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [loading]);

    return (
        <PlaydateInviteBaseView
            baseZIndex={baseZIndex}
            onBack={onBack}
            title="Easy Scheduling"
            infoText="I can help you with your invite! Add any preferences or notes for your invite (ex. time, guests, location)."
            topIcon="happy"
            useSectionDivider={false}
        >
            <TextAreaInput
                message={message}
                placeholder="Example: Afternoon after school, open to parks or backyard meetups."
                setMessage={setMessage}
                className={styles.cancellationMessageTextArea} // reuse same style for now
                height="long"
            />
            <div className={styles.buttonBuffer} />
            <div className={styles.buttonContainer}>
                <ActionButton
                    onClick={() => onSubmit(message)}
                    hasLoadingSignal={loading}
                    className={styles.cancellationPrimaryButton}
                    isLongText={true}
                >
                    {loading ? loadingMessages[messageIndex] : "Get Invite Suggestions"}
                </ActionButton>
                <ActionButton
                    onClick={() => onSkip()}
                    colorPattern="Transparent"
                    className={styles.cancellationPrimaryButton}
                    isLongText={true}
                >
                    Skip and Create Manually
                </ActionButton>
                <UnderlineButton onClick={onBack}>
                    Cancel
                </UnderlineButton>
            </div>
        </PlaydateInviteBaseView>
    );
};

export default PlaydateInviteContextIngestionView;
